// assets/bogo-pdp.js
(function () {
  const ACTIVE_CLASS = "hhb-free-active";
  const DEFAULT_OUTLINE = "rgb(204, 204, 204) solid 2px";
  const ACTIVE_OUTLINE = "rgb(0, 0, 0) solid 2px";

  function q(root, sel) {
    return (root || document).querySelector(sel);
  }
  function qa(root, sel) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function disableATC(btn, disabled) {
    if (!btn) return;
    if (disabled) {
      btn.setAttribute("disabled", "disabled");
      btn.style.opacity = "0.6";
      btn.style.pointerEvents = "none";
    } else {
      btn.removeAttribute("disabled");
      btn.style.opacity = "";
      btn.style.pointerEvents = "";
    }
  }

  function stripPaidSelectedState(btn) {
    if (!btn) return;
    ["is-active", "is-selected", "active", "selected", "current"].forEach((c) =>
      btn.classList.remove(c)
    );
    ["aria-pressed", "aria-checked", "data-selected", "data-current", "aria-current"].forEach(
      (a) => {
        if (btn.hasAttribute(a)) btn.removeAttribute(a);
      }
    );
    btn.setAttribute("type", "button");
    btn.setAttribute("aria-pressed", "false");
  }

  // ✅ Multi-currency safe formatter:
  // Keeps whatever prefix/suffix the theme already rendered (e.g. "$", "AUD", "Rs.", "INR", etc.)
  // Replaces only the numeric part.
  function formatMoneyLikeCurrent(priceEl, cents) {
    if (!priceEl) return "";

    const current = (priceEl.textContent || "").trim();

    // prefix + number + suffix (very forgiving)
    const match = current.match(/([^0-9]*)([0-9.,]+)(.*)/);

    // fallback if match fails
    const value = (cents / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    if (!match) return value;

    const prefix = match[1] || "";
    const suffix = match[3] || "";
    return `${prefix}${value}${suffix}`;
  }

  function getProductJson(productId) {
    const el = document.getElementById(`ProductJson-${productId}`);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function buildVariantPriceMap(productJson) {
    const map = {};
    const variants = productJson && productJson.variants ? productJson.variants : [];
    variants.forEach((v) => {
      // product|json usually provides price in cents (integer)
      const cents =
        typeof v.price === "number"
          ? v.price
          : Math.round(Number(v.price || 0));

      map[String(v.id)] = cents;
    });
    return map;
  }

  function init() {
    const mount = document.getElementById("bogo-free-swatch-container");
    if (!mount) return;

    const productId = mount.getAttribute("data-bogo-product-id");
    const BASE_LABEL_TEXT =
      mount.getAttribute("data-bogo-base-label") || "Choose your complimentary colour";
    const PRICE_SEL =
      mount.getAttribute("data-bogo-price-selector") || "span.current-price.theme-money";

    const productJson = getProductJson(productId);
    if (!productJson) return;

    const variantPriceById = buildVariantPriceMap(productJson);

    const form = q(document, "form.product-purchase-form");
    if (!form) return;

    const paidSelect = q(form, 'select.original-selector[name="id"]');
    const atcBtn = q(form, 'button.g-add-to-cart-btn[type="submit"]');
    if (!paidSelect || !atcBtn) return;

    // prevent double init if theme re-renders
    if (form.dataset.bogoBound === "1") return;
    form.dataset.bogoBound = "1";

    // locate paid swatches built by your "Variation Dropdown to Color Swatches" script
    const paidSwatchWrap = q(form, ".color-swatches") || q(document, ".color-swatches");
    if (!paidSwatchWrap) return;

    const paidButtons = qa(paidSwatchWrap, "button[data-value]");
    if (!paidButtons.length) return;

    let freeVariantId = null;
    let labelEl = null;
    let freeWrap = null;

    // disable until both selected
    disableATC(atcBtn, true);

    // ---------- UI build ----------
    const outer = document.createElement("div");
    outer.className = "hhb-free-swatch-wrap";

    labelEl = document.createElement("div");
    labelEl.className = "hhb-free-swatch-label";
    labelEl.textContent = BASE_LABEL_TEXT;

    freeWrap = document.createElement("div");
    freeWrap.className = "hhb-free-swatches is-disabled";

    outer.appendChild(labelEl);
    outer.appendChild(freeWrap);

    mount.appendChild(outer);

    // ---------- label ----------
    function updateLabel(name) {
      labelEl.textContent = name ? `${BASE_LABEL_TEXT}: ${name}` : BASE_LABEL_TEXT;
    }

    // ---------- price ----------
    function setPriceToMax(paidId, freeId) {
      const el = q(document, PRICE_SEL);
      if (!el) return;

      const paid = variantPriceById[String(paidId)] || 0;
      const free = variantPriceById[String(freeId)] || 0;
      const max = Math.max(paid, free || 0);

      if (max > 0) {
        el.textContent = formatMoneyLikeCurrent(el, max);
      }
    }

    // ---------- selection ----------
    function clearFreeActive() {
      qa(freeWrap, "button[data-value]").forEach((b) => {
        b.classList.remove(ACTIVE_CLASS);
        b.style.outline = DEFAULT_OUTLINE;
        b.setAttribute("aria-pressed", "false");
      });
      updateLabel(null);
    }

    function setFreeActiveById() {
      clearFreeActive();
      if (!freeVariantId) return;

      const btn = q(
        freeWrap,
        `button[data-value="${CSS.escape(String(freeVariantId))}"]`
      );

      if (btn) {
        btn.classList.add(ACTIVE_CLASS);
        btn.style.outline = ACTIVE_OUTLINE;
        btn.setAttribute("aria-pressed", "true");

        const colourName = btn.getAttribute("title") || "";
        updateLabel(colourName || null);
      }

      // update price to higher of paid/free
      setPriceToMax(Number(paidSelect.value || 0), Number(freeVariantId || 0));
    }

    function updateState() {
      const paidSelected = !!paidSelect.value;

      if (paidSelected) {
        freeWrap.classList.remove("is-disabled");
      } else {
        freeWrap.classList.add("is-disabled");
        freeVariantId = null;
        clearFreeActive();
      }

      const ok =
        paidSelected && !!freeVariantId && form.dataset.bogoSubmitting !== "1";
      disableATC(atcBtn, !ok);

      // if only paid selected, show paid price
      if (paidSelected && !freeVariantId) {
        const pid = Number(paidSelect.value || 0);
        if (pid) setPriceToMax(pid, pid);
      }
    }

    // ---------- clone paid swatches EXACTLY ----------
    paidButtons.forEach((paidBtn) => {
      const clone = paidBtn.cloneNode(true);

      // remove any selected markers but KEEP inline styles (so it matches paid)
      stripPaidSelectedState(clone);

      // ensure starting outline is grey
      clone.style.outline = DEFAULT_OUTLINE;

      clone.addEventListener("click", function (e) {
        e.preventDefault();
        if (freeWrap.classList.contains("is-disabled")) return;

        freeVariantId = clone.dataset.value;
        setFreeActiveById();
        updateState();
      });

      freeWrap.appendChild(clone);
    });

    // paid variant changes (select change triggered by your paid swatch script)
    paidSelect.addEventListener("change", function () {
      updateState();

      const pid = Number(paidSelect.value || 0);
      if (!pid) return;

      setPriceToMax(pid, freeVariantId ? Number(freeVariantId) : pid);
    });

    // ---------- submit interception (2 items only) ----------
    form.addEventListener(
      "submit",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const paidVariantId = Number(paidSelect.value || 0);
        const freeId = Number(freeVariantId || 0);

        if (!paidVariantId || !freeId) {
          updateState();
          return;
        }

        if (form.dataset.bogoSubmitting === "1") return;
        form.dataset.bogoSubmitting = "1";

        disableATC(atcBtn, true);

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            items: [
              { id: paidVariantId, quantity: 1, properties: { _bogo: "paid" } },
              { id: freeId, quantity: 1, properties: { _bogo: "free" } },
            ],
          }),
        })
          .then((r) => r.json())
          .then(() => {
            document.dispatchEvent(new CustomEvent("cart:refresh"));
            document.dispatchEvent(new CustomEvent("cart:open"));
            window.dispatchEvent(new CustomEvent("upez:cart:open"));
          })
          .finally(() => {
            form.dataset.bogoSubmitting = "0";
            updateState();
          });
      },
      true
    );

    // ---------- initial sync ----------
    clearFreeActive();
    updateState();

    if (paidSelect.value) {
      const pid = Number(paidSelect.value);
      if (pid) setPriceToMax(pid, pid);
    }
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
  
})();